import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Step1 } from '../../../../shared/models/component-messages/simp_in/step1';
import { RadioCheckBoxEnum } from '../../../common/radio.checkbox.enums';
import { CommunicationFNSSimple } from '../models/CommunicationFNSSimple';
@Component({
	selector: 'app-communicationFNS-simple',
	templateUrl: './communicationFNS-simple.component.html',
	styleUrls: ['./communicationFNS-simple.component.scss'],
})
export class CommunicationFNSSimpleComponent implements OnInit {
	@Input() uid = '';
	public current_uid = 'CommunicationFNSSimple';
	@Input() parentForm: FormGroup;
	
	@Input() disabled: boolean;
	@Input() communication: CommunicationFNSSimple;

	public readonly urlProfilAchValue = RadioCheckBoxEnum.urlProfilAchValue;
	public readonly urlDocConsulValue = RadioCheckBoxEnum.urlDocConsulValue;
	public readonly autreValue = RadioCheckBoxEnum.autreValue;

	public radioButtonValue: string;
	public radioButtonCtrlName: string;

	public step1 = new Step1();

	constructor() {}

	public ngOnInit() {
		if (this.communication.autre !== null) {
			this.radioButtonValue = this.autreValue;
		} else if (this.communication.urlDocConsul !== null) {
			this.radioButtonValue = this.urlDocConsulValue;
		} else {
			this.radioButtonValue = this.urlProfilAchValue;
		}
		this.radioButtonCtrlName = this.getUid() + '_SepAtt_urlProfilAch_radio';
	}

	getIsUrlProfilAch() {
		return this.parentForm.controls[this.radioButtonCtrlName].value === this.urlProfilAchValue;
	}

	getIsUrlDocConsul() {
		return this.parentForm.controls[this.radioButtonCtrlName].value === this.urlDocConsulValue;
	}

	getIsAutre() {
		return this.parentForm.controls[this.radioButtonCtrlName].value === this.autreValue;
	}

	public getUid() {
		return this.uid + '_SepSep_' + this.current_uid;
	}
}
